import axios from 'axios'

export const getRosekPersekolah = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-rosek-sekolah/" + payload.sekolah_id + "/" + payload.tajar_id)
            .then((response) => {
                commit('SET_ROSEKS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve(response.data)
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const getRosekPersekolahSolo = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-rosek-sekolah-solo/" + payload.sekolah_id + "/" + payload.tajar_id)
            .then((response) => {
                commit("SET_OVERLAY", false, { root: true });
                resolve(response.data)
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}


export const storeRosek = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-rosek", payload).then((response) => {
            let notif = {
                msg: nama + " Berhasil ditambahkan~",
                type: "create"
            }
            commit("SET_NOTIF", notif, { root: true });
            let temp = {
                sekolah_id: payload.sekolah_id,
                tajar_id: payload.tajar_id
            }
            dispatch("getRosekPersekolah", temp);
            resolve("ok")
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const updateRosek = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-rosek", payload).then((response) => {
            let notif = {
                msg: nama + " Berhasil diupdate~",
                type: "update"
            }
            commit("SET_NOTIF", notif, { root: true });
            let temp = {
                sekolah_id: payload.sekolah_id,
                tajar_id: payload.tajar_id
            }
            dispatch("getRosekPersekolah", temp);
            resolve("ok")
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const deleteRosek = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-rosek/" + payload.id).then((response) => {
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            }
            let temp = {
                sekolah_id: payload.sekolah_id,
                tajar_id: payload.tajar_id
            }
            dispatch("getRosekPersekolah", temp).then(() => {
                commit("SET_NOTIF", notif, { root: true });
            });
            resolve("ok")
        }).catch((e) => {
            if (e.response.data.exist) {
                let existNotif = {
                    msg: "Data tidak dapat dihapus karena data guru telah diisi pada rombel!",
                    type: "kadaboleh"
                }
                commit("SET_NOTIF", existNotif, { root: true });
            }
            commit("SET_OVERLAY", false, { root: true });
            reject("fail")
        });
    })
}

export const updateRomagus = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.rosek_nama;
    return new Promise((resolve, reject) => {
        axios.post("/api/update-romagus", payload).then((response) => {
            let notif = {
                msg: nama + " Berhasil diupdate~",
                type: "update"
            }
            commit("SET_NOTIF", notif, { root: true });
            let temp = {
                sekolah_id: payload.sekolah_id,
                tajar_id: payload.tajar_id
            }
            dispatch("getRosekPersekolah", temp).then(() => {
                commit("SET_NOTIF", notif, { root: true });
            });
            resolve("ok");
        }).catch((e) => {
            reject("fail");
        })
    })
}

export const salinRoseks = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios.post('/api/salin-roseks', payload).then((res) => {
            if (res.data == "exist") {
                resolve("exist")
                commit("SET_OVERLAY", false, { root: true });
            } else {
                let notif = {
                    msg: "Data rombel berhasil disalin~",
                    type: "create"
                }
                commit("SET_NOTIF", notif, { root: true });
                let temp = {
                    sekolah_id: payload.sekolah_id,
                    tajar_id: payload.tajar_aktif_id
                }
                dispatch("getRosekPersekolah", temp).then(() => {
                    commit("SET_NOTIF", notif, { root: true });
                });
                resolve("ok");
            }
        }).catch((e) => {
            reject("fail");
        })
    })
}